import React, { FunctionComponent, ReactNode } from 'react';

import { ButtonProps as RSButtonProps } from 'reactstrap/lib/Button';

import { StyledButton } from './styled';

export type ButtonProps = RSButtonProps & {
  children: ReactNode;
};

const Button: FunctionComponent<ButtonProps> = ({
  children,
  ...props
}: ButtonProps) => {
  return <StyledButton {...props}>{children}</StyledButton>;
};

export default Button;
